import { type webidStartRequestSchema } from 'xosign-types';
import { type z } from 'zod';

export type WebidStartRequest = z.infer<typeof webidStartRequestSchema>;

/**
 * The outcome WebID appends to its redirect URL (`?webid=...`). Single source of
 * the contract the backend's withOutcome() builder emits — consumed by both the
 * KYC return page and the sign-flow WebID return page.
 */
export type WebidOutcome = 'success' | 'declined' | 'mismatch' | 'cancelled';

export const isWebidOutcome = (value: string | null): value is WebidOutcome =>
  value === 'success' ||
  value === 'declined' ||
  value === 'mismatch' ||
  value === 'cancelled';
